export default __webpack_public_path__ + "static/media/room-icon.8bca23d0.svg";